<script setup lang="ts">
import { RouterView } from 'vue-router';

import AppSidebar from '@/modules/analyzer/components/AppSidebar.vue';
import AppToast from '@/shared/components/AppToast.vue';
</script>

<template>
  <div
    class="grid h-screen grid-cols-[290px_1fr] overflow-hidden max-[820px]:grid-cols-1 print:block print:h-auto print:overflow-visible"
  >
    <AppSidebar />
    <main class="relative overflow-y-auto print:overflow-visible">
      <RouterView />
    </main>
  </div>
  <AppToast />
</template>
